import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PageNames} from '../../shared/page-names.enum';
import {TvShopEntertainmentPack} from '../../model/tv-shop-entertainment-pack';
import {NavigationService} from '../../services/navigation/navigation.service';
import {BaseActions} from '../../shared/base-actions';
import {Order} from '../../model/order';
import {ImageUtils} from '../../shared/utils/image/image-utils';
import {OmapiIdConstants} from '../../shared/omapi-id-constants';

@Component({
  selector: 'app-product-detail-entertainment',
  templateUrl: './product-detail-entertainment.component.html',
  styleUrls: ['./product-detail-entertainment.component.less']
})
export class ProductDetailEntertainmentComponent extends BaseActions {
  @Input()
  titleKey: string;

  @Input()
  descriptionKey: string;

  @Input()
  hasLogo: boolean;

  @Input()
  showBannerImage = true;

  @Input()
  belowOrderTextKey: string;

  @Output()
  emitOrderProduct = new EventEmitter<Object>();

  @Input()
  componentName = PageNames.DETAIL_PAGE_ENTERTAINMENT;

  @Input()
  pack: TvShopEntertainmentPack;

  @Input()
  subPack: TvShopEntertainmentPack;

  constructor(private navigationService: NavigationService) {
    super();
  }

  public get backgroundImageUrl(): string {
    return ImageUtils.getBackgroundImageUrl(this.pack.omapiId, this.componentName);
  }

  public get bannerImageUrl(): string {
    return ImageUtils.getBannerImageUrl(this.pack.omapiId, this.componentName);
  }

  public get logoUrl(): string {
    return ImageUtils.getLogoUrlForOmapiId(this.pack.omapiId);
  }

  public get isOmapiBETVSport(): boolean {
    return this.pack && this.pack.omapiId !== OmapiIdConstants.BE_TV_SPORT_VLA;
  }

  public onEmitOrderProduct(event: Order): void {
    if (!this.pack.isOrderable() && this.subPack && this.subPack.isOrderable()) {
      this.transformSubpackToPack(event);
    }
    this.emitOrderProduct.emit(event);
  }


  private transformSubpackToPack(event: Order) {
    event.packOmapiId = event.subPackOmapiId;
    event.packPrice = event.subPackPrice;
    event.subPackOmapiId = undefined;
    event.subPackPrice = undefined;
  }

  onBack(): void {
    this.navigationService.resetPage();
  }

}
